import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ESocialType } from '../../types/social';
import { getIgnoreSocialDataForRegistration } from './getIgnoreSocialDataForRegistration';
var getResolution = function getResolution(socialType) {
  switch (socialType) {
    case ESocialType.AppleID:
      return [800, 600];
    default:
      return [400, 480];
  }
};
export function open(parameters) {
  var socialType = parameters.socialType;
  return function (dispatch, getState, context) {
    var config = context.config;
    var _getResolution = getResolution(socialType),
      _getResolution2 = _slicedToArray(_getResolution, 2),
      width = _getResolution2[0],
      height = _getResolution2[1];
    var top = (window.outerHeight - height) / 2;
    var left = (window.outerWidth - width) / 2;
    var ignoreSocialDataForRegistration = String(getIgnoreSocialDataForRegistration(socialType, config));
    var socialLoginV2FlowEnabled = config.get('auth.socialLoginV2Flow.enabled') || false;
    var popupParams = ["width=".concat(width), "height=".concat(height), "scrollbars=0", "top=".concat(top), "left=".concat(left)].join(', ');
    window.open("/auth/social-login/?type=".concat(socialType, "&ignoreSocialDataForRegistration=").concat(ignoreSocialDataForRegistration, "&v2Flow=").concat(socialLoginV2FlowEnabled), 'Meow 🐾', popupParams);
  };
}